<template>
<div v-if="passive == false" class="image-view"
    @touchstart="listen__view__on_x_down($event, 'touch')"
    @mousedown="listen__view__on_x_down($event, 'mouse')"
    @wheel="listen__view__onwheel">
  <frame
    style="background:rgba(0, 0, 0, 0);"
    ref="frame"
    :frame-data="frameData"
    :pred="pred"
    :initial-tool-option="initialToolOption"
    @onstatechange="listen__frame__onstatechange" />
  <q-inner-loading :showing="frameData._empty == true">
    <q-icon class="image-view-layer-icon" name="file_upload" size="md" style="color:#888888;" />
    <span class="image-view-layer-message" style="color:#666666;user-select:none" v-for="(m, i) in state.messagesUpload" :key="`message-upload-${i}`">{{ m }}</span>
  </q-inner-loading>
</div>
<div v-else class="image-view">
  <frame
    style="background:rgba(0, 0, 0, 0);"
    ref="frame"
    :frame-data="frameData"
    :pred="pred"
    :initial-state="initialFrameState"
    :initial-tool-option="initialToolOption" />
</div>
</template>

<script>
import Frame from '@/projects/ocr/components/Frame'

export default {
  props: {
    passive: Boolean,
    frameData: Object,
    pred: Array,
    type: Number,
    initialFrameState: Object,
    initialToolOption: Object,
    messagesUpload: Array,
  },
  data: function () {
    const Vue = this
    return {
      state: {
        messagesUpload: Vue.messagesUpload == undefined ? ['마우스로 파일을 드래그하거나 upload image를 클릭하여', '이미지를 업로드 해주세요.'] : Vue.messagesUpload
      }
    }
  },
  components: {
    Frame
  },
  methods: {
    listen__view__on_x_down: function (e, type) {
      this.$refs['frame'].listen__view__on_x_down(e, type);
    },
    listen__view__onwheel: function (e) {
      this.$refs['frame'].listen__view__onwheel(e);
    },
    listen__frame__onstatechange: function (data) {
      this.$emit('onstatechange', data)
    },
    tostatechange: function (data) {
      this.$refs['frame'].listen__state__tochange(data)
    },
    fitToWindow() {
      this.$refs['frame'].fitToWindow()
    },
    updateTagging() {
      this.$refs['frame'].updateTagging()
    },
    setToolOption(key, value) {
      this.$refs['frame'].setToolOption(key, value)
    }
  }
}
</script>

<style scoped>
.image-view {
  display: block;
  position: relative;
  background-color: #f0f0f0;
  background-image: 
    linear-gradient(45deg,#e0e0e0 25%,transparent 0,transparent 75%,#e0e0e0 0,#e0e0e0),
    linear-gradient(45deg,#e0e0e0 25%,transparent 0,transparent 75%,#e0e0e0 0,#e0e0e0);
  background-size: 40px 40px;
  background-position: 0 0,20px 20px;
  background-position-x: 0px, 20px;
  background-position-y: 0px, 20px;
  overflow: hidden;
}

@media (max-width: 950px) {
  .image-view-layer-message {
    display: none !important;
  }
}
</style>